import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";
import { UserFields } from '../../Endpoint/UserFields';

class DefaultFieldsFilter extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	render() {

		const { addSubField, group } = this.props;

		const defaultFields = [];

		UserFields.forEach((el) => {
			if ( el.value === 'ID' || el.value === 'user_registered' ) {
				return;
			}

			if ( el.value === 'roles' ) {
				defaultFields.push( getFieldFactory().getRolesFieldGroup( 'select', 'roles', 'User role' ) );
			} else {
				defaultFields.push( getFieldFactory().getNewDefaultFieldGroup( el.value, el.name, 'input', '' ) );
			}
		});

		defaultFields.push( getFieldFactory().getNewDefaultFieldGroup( 'user_pass', 'User Password', 'input', '' ) );

		return (
			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (

					<React.Fragment>
						<h3>Default Fields ({endpoint.createUsers[currentItem].defaultFields.length})</h3>

						<ParametersNotice parameters={endpoint.parameters}/>

						<select value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
							<option value="">Select a field</option>
							{defaultFields.map((el, index) => <option key={index} value={el.name}>{el.label}</option>)}
						</select>

						<button
							onClick={() => addSubField(endpointId, defaultFields.filter(el => el.name === this.state.selectedFilterToAdd), currentItem, group, action)}
							disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
							className="button-secondary"
						>
							Add
						</button>

						<FieldGroups group={group} />

					</React.Fragment>
				)}

			</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(DefaultFieldsFilter);
